import React from 'react';
import { Errors } from 'react-redux-form';
import { CustomFileUploader } from 'components/customFileUploader/CustomFileUploaderContainer';
import { i18n } from 'core/i18n';

const { formatText } = i18n;

export const UploadFileBox = ({
    id,
    title,
    countBoxes,
    docId,
    onHandleManageValidation,
    onHandleFileReceived,
    onHandleRemovedFile,
    handleModal,
    dropzoneRef,
}) => {
    const getColumnWidth = countBoxes => {
        if (countBoxes === 1 || countBoxes === 5 || countBoxes === 7) {
            return 12;
        }

        return (countBoxes % 2 && !(countBoxes % 3)) || (!(countBoxes % 2) && !(countBoxes % 3)) ? 4 : 6;
    };

    const columnWidth = getColumnWidth(countBoxes);

    const renderErrors = ({ children }) => {
        return <p className="form__field_error">{children}</p>;
    };

    const handleOnClickWrapper = event => {
        handleModal(event, docId);
    };

    return (
        <div className={`col-xs-12 col-sm-${columnWidth} file-uploader-container`} key={id}>
            <CustomFileUploader
                id={id}
                profileModel={`userProfile.documentToUpload_${id}`}
                title={title}
                fileType={['image/png', 'image/bmp', 'image/jpeg', 'application/pdf']}
                docId={docId}
                handleValidation={onHandleManageValidation}
                handleFileReceived={onHandleFileReceived}
                handleRemovedFile={onHandleRemovedFile}
                handleClicToShowModal={handleOnClickWrapper}
                ref={dropzoneRef}
            />
            <Errors
                model={`userProfile.documentToUpload_${id}`}
                messages={{
                    required: formatText('validation-documentRequired'),
                }}
                component={renderErrors}
            />
        </div>
    );
};
